var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"percent-circle"},[_c('div',{ref:"container",staticStyle:{"width":"100px","height":"100px"}}),_c('div',{staticClass:"percent-text"},[_vm._v(_vm._s(_vm.percent)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }